<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance Move in'}">{{ $root.getHeader() }} Finance MoveIn/MoveOut </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never" v-loading="loading">
      <template slot="header">
       <el-date-picker
        v-model="date"
        @change="getUnits"
        type="month"
        />
      </template>
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <el-card shadow="never" v-loading="loading">
            <template slot="header">
              Move In
            </template>
            <el-table :data="moveIn" @row-click="routeToCustomer">
              <el-table-column label="Move In">
                <template slot-scope="scope">
                  {{ scope.row.moveIn | formatDate }}
                </template>
              </el-table-column>
              <el-table-column prop="unit.name" label="Unit Name"></el-table-column>
              <el-table-column prop="unit.size" label="Unit size"></el-table-column>
              <el-table-column prop="customer.company" label="Customer"></el-table-column>
            </el-table>
           </el-card>
        </el-col>
        <el-col :span="12">
         <el-card shadow="never" v-loading="loading">
            <template slot="header">
              Move Out
            </template>
            <el-table :data="moveOut" @row-click="routeToCustomer">
              <el-table-column label="Move Out">
                <template slot-scope="scope">
                  {{ scope.row.moveOut | formatDate }}
                </template>
              </el-table-column>
              <el-table-column prop="unit.name" label="Unit Name"></el-table-column>
              <el-table-column prop="unit.size" label="Unit size"></el-table-column>
              <el-table-column  prop="customer.company" label="Customer"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </el-card>
</template>

<script>
import axios from 'axios';
import { UNIT_RENTAL_API_BASE } from '../env';

export default {
  name: 'FinanceMove',
  props: {
    facility: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      moveIn: [],
      moveOut: [],
      date: new Date(),
    };
  },
  watch: {
    async facility() {
      await this.getUnits();
    },
  },
  async mounted() {
    await this.getUnits();
  },
  methods: {
    async getUnits() {
      this.loading = true;
      const response = await axios.get(`${UNIT_RENTAL_API_BASE}/finance/facility/${this.facility}/unit/moves`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          limit: 250,
          ...(this.facility ? { facility: this.facility } : {}),
          month: this.date.getMonth(),
          year: this.date.getFullYear(),
        },
      });
      this.loading = false;
      this.moveIn = response.data.result.moveInUnits;
      this.moveOut = response.data.result.moveOutUnits;
    },
    routeToCustomer(row) {
      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.customer && row.customer._id ? row.customer._id : row.customer._id, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: row.customer && row.customer._id ? row.customer._id : row.customer._id } });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FinanceMove.vue